import React, { useEffect, useState } from "react";
import moment from "moment";
import Timer from "react-compound-timer";
import "../css/Timer.scss"; // Import the SCSS file

const TimerComponent = ({ labAvailableTill, onTimeUp, millisecondsLeft }) => {
  const [today, setToday] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setToday(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, [labAvailableTill]);

  let timeLeft = moment(labAvailableTill).diff(moment(today), "seconds") * 1000;

  if (millisecondsLeft && millisecondsLeft > 0) {
    timeLeft = millisecondsLeft;
  }

  return (
    <div className="timer-container">
      <div className="text-center my-1" style={{ color: "#156B7E", fontSize: "20px" }}>
        <b>Time Left</b>
      </div>
      <div className="timer">
        {(labAvailableTill || millisecondsLeft > 0) && timeLeft > 0 ? (
          <Timer
            initialTime={timeLeft}
            startImmediately={true}
            direction="backward"
            checkpoints={[
              {
                time: 0,
                callback: onTimeUp
              }
            ]}
          >
            {({ timerState }) => (
              <React.Fragment>
                <div className="timer-digits" style={{ color: "red" }}>
                  <Timer.Days />D : <Timer.Hours />H : <Timer.Minutes />M : <Timer.Seconds />S
                </div>
                {timerState === "STOPPED" && (
                  <div className="timer-message">
                    Submission deadline is over
                  </div>
                )}
              </React.Fragment>
            )}
          </Timer>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default TimerComponent;
